import { Outlet } from 'react-router';

/**
 * ExternalLayout - Minimal layout for external-facing pages
 * Used for public registration pages and other external flows
 * that should not display the main site navigation/chrome
 */
export function ExternalLayout(): JSX.Element {
  return <Outlet />;
}

export default ExternalLayout;
